// extracted by mini-css-extract-plugin
module.exports = {"borderBottom":"HeadDetail_borderBottom__cu0M9","transitionToOpen":"HeadDetail_transitionToOpen__cNpQC","transitionToClose":"HeadDetail_transitionToClose___gq_j"};